


















































































import companyType from '@/store/types/company';
import DatesFormat from '@/util/classes/datesFormat';
import { itemsRoute, navLink } from '@/ts/navegationLinks';
import liquidations from '@/store/types/liquidations';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'CompanyProfile',
  data: () => ({
    isLoading: true,
    items: [
      {
        id: 1,
        can: 'show_companies',
        icon: 'ni ni-circle-08',
        title: 'Perfil',
        route: 'company-profile',
        hash: 'perfil',
      },
      {
        id: 2,
        icon: 'fas fa-file-alt',
        title: 'Documentos',
        can: 'index_company_documents',
        route: 'company-documents',
        hash: 'documentos',
      },
      {
        id: 3,
        can: 'index_contacts',
        icon: 'ni ni-circle-08',
        title: 'Contactos',
        route: 'company-contacts',
        hash: 'contactos',
      },
      {
        id: 4,
        can: 'index_branches',
        icon: 'ni ni-shop',
        title: 'Sucursales',
        route: 'company-branches',
        hash: 'sucursales',
      },
      {
        id: 5,
        can: 'index_company_commerces',
        icon: 'ni ni-building',
        title: '', // assigned in created
        route: 'company-commerce',
        hash: 'comercios',
      },
      {
        id: 6,
        can: 'show_bank_accounts',
        icon: 'ni ni-credit-card',
        title: 'Cuentas',
        route: 'bank-accounts',
        hash: 'cuentas',
      },
      {
        id: 7,
        can: 'index_company_company_users',
        icon: 'fa fa-users',
        title: 'Usuarios teip Biz',
        route: 'company-users',
        hash: 'biz',
      },
      {
        id: 8,
        can: 'index_company_company_users',
        icon: 'fa fa-qrcode',
        title: 'Códigos QR',
        route: 'company-qr-code',
        hash: 'codigos',
      },
      {
        id: 9,
        can: 'branch_payment_links_companies',
        icon: 'fa fa-link',
        title: 'Enlaces de pago',
        route: 'payments-link',
        hash: 'payments',
      }
    ] as itemsRoute[],
    navlink: [
      {
        name: '', // assigned in created function
        active: false,
        to: '/commerce/company',
      },
      {
        name: '',
        active: true,
      }
    ] as navLink[],
  }),
  computed: {
    ...mapGetters({
      getSingleCompany: `companyModule/${companyType.getters.GET_SINGLE_COMPANY}`,
    }),
  },
  created() {
    this.$data.navlink[0].name = this.$t('menu.company.singular.formal').toString();
    this.$data.navlink[1].name = `Perfil de ${this.$t('menu.company.singular.informal').toString()}`;
    this.$data.items[4].title = this.$t('menu.commerce.plural.formal').toString();
  },
  async mounted() {
    const company_id = this.$route.params.company_id;
    await this.singleCompanyAction(company_id);
    this.liquidationKindList();
    this.$data.isLoading = false;
  },
  methods: {
    ...mapActions({
      singleCompanyAction: `companyModule/${companyType.actions.SINGLE_COMPANY}`,
      liquidationKindList: `liquidationModule/${liquidations.actions.LIQUIDATION_KIND_LIST}`,
    }),
    createdAt(date: string): string {
      const dateFormat = new DatesFormat();
      return dateFormat.formatDate(date);
    },
  },
});
